module.exports = __webpack_public_path__ + "img/curso-e-ensino-tecnico.07876e0c.png";